import {v1 as uuid} from 'uuid';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TariffOptionConfiguration} from '../model/tariff-option-configuration';
import {CalculationResponse} from '../model/calculation-response';
import {CalculationRequest} from '../model/calculation-request';
import {IError} from '../model/interface/i-error';
import {PricesWrapper} from '../model/prices-wrapper';

const API_URL = '/api/ukv/calculate/';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private static PRODUCT_ID_VOLLVERSICHERUNG = 'Vollversicherung';

  public baseUrl = '';
  public product = '';
  public isBusy = false;

  private httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*'
    })
  };

  private httpClient: HttpClient;
  public lastErrors: IError[] = [];

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public async post(path: string, data: any): Promise<any> {
    return await this.httpClient.post(this.baseUrl + path, data, this.httpOptions).toPromise();
  }

  calculateTariff(
    tariffOptions: Map<string, TariffOptionConfiguration>,
    prices: Map<string, PricesWrapper>,
    sessionId: string,
    mandantId: string
  ): Promise<CalculationResponse> {
    // typescript maps can't be used when posting data via angulars HttpClient
    // therefore we will have to transform it into a dynamic object
    const tempTocs = {};
    tariffOptions.forEach((toc: TariffOptionConfiguration, key: string) => {
      if (key && key.length > 0) {
        tempTocs[key] = toc;
      }
    });
    const tempPrices = {};
    prices.forEach((price: PricesWrapper, key: string) => {
      if (key && key.length > 0) {
        tempPrices[key] = price;
      }
    });

    this.isBusy = true;
    return new Promise((resolve, reject) => {

      const request = new CalculationRequest();
      request.sessionId = sessionId;
      request.mandantId = mandantId;
      request.uuid = uuid();
      request.tariffOptionConfigurations = tempTocs;
      request.prices = tempPrices;

      this.lastErrors = [];

      this.post(API_URL + this.product, request).then((response: any) => {

        const calculationResponse = response as CalculationResponse;
        this.lastErrors = calculationResponse.errors;
        this.updateTariffOptionConfigurations(calculationResponse, tariffOptions, prices);
        this.isBusy = false;

        resolve(calculationResponse);
      }).catch((e: any) => {
        console.log(e);
        this.isBusy = false;
        const errorMsg = 'Es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es später erneut.';
        this.lastErrors.push({
          message: errorMsg
        });
        reject(errorMsg);
      });
    });
  }

  private updateTariffOptionConfigurations(calculationResponse: CalculationResponse,
                                           tariffOptions: Map<string, TariffOptionConfiguration>,
                                           prices: Map<string, PricesWrapper>) {
    const tocsRes = calculationResponse.tariffOptionConfigurations;
    for (const key in tocsRes) {
      if (tocsRes.hasOwnProperty(key)) {
        const element = tocsRes[key];
        tariffOptions.set(key, element);
      }
    }
    const pricesRes = calculationResponse.prices;
    for (const key in pricesRes) {
      if (pricesRes.hasOwnProperty(key)) {
        const element = pricesRes[key];
        prices.set(key, element);
      }
    }
  }

  public isUsingEmployersContribution() {
    return this.product === ApiService.PRODUCT_ID_VOLLVERSICHERUNG;
  }

  public isUsingDefaultProfileValues() {
    return true;
  }
}
